import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Button, Icon } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import styles from './BasketLine.module.scss';

export interface ApplicationBasketLineProps {
	name?: string;
	categories?: string[];
	enableDiscount?: boolean;
	toggleDiscountFeature?: () => void;
}

export const ApplicationHeadLine: React.FunctionComponent<ApplicationBasketLineProps> = ({
	name,
	categories,
	enableDiscount,
	toggleDiscountFeature,
}) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);

	const nameList = useMemo(() => {
		if (!categories || !name) {
			return [];
		}
		return categories?.map((n) => n.trim()) ?? [name];
	}, [name, categories]);

	return (
		<div className={styles.lineWrapper}>
			<div className={styles.headline}>
				<div className={classNames(styles.productField, styles.padding)}>
					{nameList.length > 0 &&
						nameList.map((n, index) => (
							<div key={index} className={styles.basketLineTitle}>
								{n}
							</div>
						))}
				</div>
				<div className={classNames(styles.field, styles.padding, styles.center, styles.amount)}>
					{translations?.data.basket.amount}
				</div>
				<div className={classNames(styles.field, styles.padding, styles.center, styles.price)}>
					{translations?.data.basket.price}
				</div>
				<div className={classNames(styles.field, styles.padding, styles.customerDiscount)}>
					{translations?.data.basket.customerDiscount}
				</div>
				<div className={classNames(styles.field, styles.padding, styles.salesRepDiscount)}>
					{enableDiscount ? (
						translations?.data.basket.salesRepDiscount
					) : (
						<Button
							onClick={toggleDiscountFeature}
							hasOnlyIcon
							aria-label={'toggle discount feature'}
							variant={'ghost'}
						>
							<Icon name={'edit'} size={'sm'} />
						</Button>
					)}
				</div>
				<div className={classNames(styles.field, styles.padding, styles.center, styles.price)}>
					{translations?.data.basket.total}
				</div>
			</div>
		</div>
	);
};
